import React from 'react';
import { Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-152">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-153">
          <div className="md:col-span-1" data-id="element-154">
            <h2 className="text-2xl font-bold text-indigo-400 mb-4" data-id="element-155">Turnout</h2>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-156">
              Personalized outreach for community events. Reduce no-shows from
              the tools you already use.
            </p>
            <div className="flex space-x-4" data-id="element-157">
              <a href="https://x.com/turnout_info" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-158">
                <Twitter size={20} data-id="element-159" />
              </a>
              <a href="https://www.linkedin.com/company/turnout-info" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-160">
                <Linkedin size={20} data-id="element-161" />
              </a>
            </div>
          </div>
          <div data-id="element-162">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-163">Features</h3>
            <ul className="space-y-3" data-id="element-164">
              <li data-id="element-165">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-166">
                  Personalized Outreach
                </a>
              </li>
              <li data-id="element-167">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-168">
                  Automated Follow-ups
                </a>
              </li>
              <li data-id="element-169">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-170">
                  Audience Segmentation
                </a>
              </li>
              <li data-id="element-171">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-172">
                  Attendance Tracking
                </a>
              </li>
              <li data-id="element-173">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-174">
                  Luma Integration
                </a>
              </li>
              <li data-id="element-175">
                <a href="#features" className="text-gray-400 hover:text-white transition-colors" data-id="element-176">
                  Smart Automation
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-177">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-178">Company</h3>
            <ul className="space-y-3" data-id="element-179">
              <li data-id="element-180">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-181">
                  About Us
                </a>
              </li>
              <li data-id="element-182">
                <a href="#case-studies" className="text-gray-400 hover:text-white transition-colors" data-id="element-183">
                  Case Studies
                </a>
              </li>
              <li data-id="element-184">
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors" data-id="element-185">
                  Testimonials
                </a>
              </li>
              <li data-id="element-186">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-187">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-188">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-189">Legal</h3>
            <ul className="space-y-3" data-id="element-190">
              <li data-id="element-191">
                <a href="https://docs.google.com/document/d/1HAZaZGu4ejcYphouQQGkXGUJd2il_LeQ6eTjj86GCQE/edit?usp=drive_web&ouid=107501030604000419011" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-192">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-193">
                <a href="https://docs.google.com/document/d/1SB9umObVrSOeRQ980QkfM6CooUfdz4gMGKM_DGYPego/edit?tab=t.0" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" data-id="element-194">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-gray-800 text-center text-gray-500" data-id="element-195">
          <p data-id="element-196">&copy; {currentYear} Turnout. All rights reserved.</p>
          <p className="mt-2 text-sm" data-id="element-197">Academi Technologies Inc.</p>
        </div>
      </div>
    </footer>;
}